import React from 'react';
import { theme } from './theme';
import { buildHotelSearchUrl, buildThingsToDoUrl, cityFromAirportName } from './utils/dealExtras';

// TripExtras: the one "Plan the rest of your trip" section, shared by the
// Deal page and the Price Watch page so both carry the same name, label and
// look (Oct 10, per Ali). Two free links (hotels, things to do) that are not
// part of the flight price. Anything passed as children (the Price Watch page
// puts "Watch another trip" and "Refer a friend" here) renders as a second
// row inside the same card. The affiliate disclosure line goes in the footer
// note once these links earn a commission.
//
// `pin` only needs: destination, departure_date (or matched_departure_date),
// return_date (or matched_return_date), adults, child_ages.
export function SectionLabel({ children, style }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', ...style }}>
      <span style={{ fontFamily: theme.fontMono, fontSize: '11px', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.1em', color: '#4A5F78', whiteSpace: 'nowrap' }}>{children}</span>
      <span style={{ flex: 1, height: '1px', background: '#C3CFDA' }} />
    </div>
  );
}

// First part of "Oslo , Gardermoen" / "São Paulo – Guarulhos". Returns '' when
// the name is missing or too long to read well on a button (a bare airport
// name such as "Sultan Aji Muhammad Sulaiman Sepinggan").
function shortCity(destination) {
  const first = String(cityFromAirportName(destination) || '').split(/\s*[,–—]\s*|\s+-\s+/)[0].trim();
  return first && first.length <= 22 ? first : '';
}

export default function TripExtras({ pin, wide, children }) {
  if (!pin || !pin.destination) return null;
  const city = shortCity(pin.destination);
  const hasDates = !!(pin.matched_departure_date || pin.departure_date);
  const card = { flex: '1 1 260px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px', textDecoration: 'none', background: '#fff', border: '1.5px solid #C3CFDA', borderRadius: '14px', padding: '13px 16px' };
  const arrow = <span aria-hidden="true" style={{ fontWeight: 800, color: theme.structural }}>→</span>;
  const box = wide ? { maxWidth: '1180px', margin: '0 auto' } : {};
  return (
    <>
      <SectionLabel style={{ ...box, margin: wide ? '24px auto 14px' : '28px 0 14px' }}>Plan the rest of your trip</SectionLabel>
      <div style={{ ...box, background: '#fff', border: '1px solid #DDE3E7', borderLeft: '6px solid #F4C11C', boxShadow: '0 2px 10px rgba(30,58,95,0.07)', borderRadius: '16px', padding: '16px 18px' }}>
        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          {hasDates && (
            <a href={buildHotelSearchUrl(pin)} target="_blank" rel="noopener noreferrer" style={card}>
              <div>
                <div style={{ fontSize: '14.5px', fontWeight: 800, color: theme.structural }}>{city ? `Hotels in ${city}` : 'Hotels at your destination'}</div>
                <div style={{ fontSize: '12px', color: theme.textMuted }}>Browse on Booking.com</div>
              </div>
              {arrow}
            </a>
          )}
          <a href={buildThingsToDoUrl(pin)} target="_blank" rel="noopener noreferrer" style={card}>
            <div>
              <div style={{ fontSize: '14.5px', fontWeight: 800, color: theme.structural }}>{city ? `Things to do in ${city}` : 'Things to do there'}</div>
              <div style={{ fontSize: '12px', color: theme.textMuted }}>Browse on Viator</div>
            </div>
            {arrow}
          </a>
        </div>
        <p style={{ fontSize: '12px', color: theme.textMuted, margin: '10px 0 0' }}>
          Not priced or included in your flight total{wide ? ' above' : ''}.
        </p>
        {children && (
          <div style={{ marginTop: '14px', paddingTop: '14px', borderTop: '1px solid #DDE3E7' }}>{children}</div>
        )}
      </div>
    </>
  );
}
